import React from 'react';
import axios from 'axios';
import { Button, Col, Row, Label, FormText, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

const token_id = localStorage.getItem('token');

const textTd = {
  project_name: 'ชื่อโครงการ',
  project_start: 'ระยะเวลาดําเนินโครงการ (เริ่มต้น)',
  project_finish: 'ระยะเวลาดําเนินโครงการ (สิ้นสุด)',
  project_object: 'วัตถุประสงค์โครงการ',
  project_output_goal: 'เป้าหมายเชิงผลผลิต',
  project_outcome_goal: 'เป้าหมายเชิงผลลัพธ์',
  project_expected_benefit: 'ผลที่คาดว่าจะได้รับ',
  project_benefit: 'กลุ่มเป้าหมาย/ผู้ที่ได้รับประโยชน์',
  project_type_name: 'ข้อมูลประเภทโครงการ',
  project_national_strategy_name: 'ข้อมูลยุทธศาสตร์ชาติ 20 ปี',
  project_master_plan_name: 'แผนแม่บทชาติ',
  project_development_plan_name: 'แผนพัฒนาเศรษฐกิจ',
  project_development_goal_name: 'เป้าหมายการพัฒนาที่ยั่งยืน (SDGs)',
  project_province_strategy_name: 'ข้อมูลยุทธศาสตร์จังหวัด',
  project_local_strategy_name: 'ข้อมูลยุทธศาสตร์องค์การปกครองท้องถิ่น (อปท.)',
  project_municipality_strategy_name: 'ข้อมูลยุทธศาสตร์เทศบาลนครนนทบุรี',
  project_sub_strategy_name: 'กลยุทธ์',
  project_non_livable_name: 'ข้อมูล 6 ดีของจังหวัดนนทบุรี',
  project_it_master_plan_name: 'ข้อมูลแผนปฎิบัติการดิจิทัลระยะ 5 ปี',
  project_smart_city_name: 'ข้อมูล Smart City',
  project_plan_name: 'ข้อมูลแผนงาน',
  project_policy_name: 'ข้อมูลนโยบายนายกเทศมนตรีประจําปี',
  project_revenue_budget_type_name: 'แหล่งที่มาของเงินงบประมาณ (งบประมาณรายรับ)',
  project_expenditure_budget_type_name: 'เงินงบประมาณ (งบประมาณรายจ่าย)',
  project_total_budget: 'ยอดงบประมาณโครงการ',
  project_department_name: 'หน่วยงานเจ้าของโครงการ',
  project_responsible: 'ผู้รับผิดชอบโครงการ',
  project_note: 'หมายเหตุ/บันทึก',
  create_user_data: 'ข้อมูลผลการดำเนินงานของเจ้าของโครงการ',
  project_status: 'สถานะของโครงการ',
};

export default class ImportProject extends React.Component {
  state = {
    excelData: null,
    ArrayData: [],
    logError: null,
    apiErrors: [],
    loading: false, // สถานะของโหลดดิ่ง
  };

  toGregorianYear = year => {
    const numericYear = Number(year);
    if (!Number.isFinite(numericYear)) return null;
    return numericYear > 2400 ? numericYear - 543 : numericYear;
  };

  normalizeHeader = value => String(value ?? '').normalize('NFKC').replace(/\s+/g, '');

  getImportField = header => {
    const normalized = this.normalizeHeader(header);
    // รองรับชื่อที่สะกดต่างกันในไฟล์แผนดำเนินงานเดิม
    if (normalized === this.normalizeHeader('ข้อมูลนโนบายนายกเทศมนตรีประจำปี')) return 'project_policy_name';
    return Object.keys(textTd).find(key => key === normalized || this.normalizeHeader(textTd[key]) === normalized) || String(header).trim();
  };

  normalizeImportRow = row => Object.keys(row).reduce((result, header) => {
    result[this.getImportField(header)] = row[header];
    return result;
  }, {});

  // รองรับ: Excel serial number, dd/mm/yyyy, yyyy-mm-dd, dd-mm-yyyy และ Date object
  chengDate = e => {
    if (e === undefined || e === null || e === '') return '';

    if (e instanceof Date && !isNaN(e)) {
      const d = String(e.getDate()).padStart(2, '0');
      const m = String(e.getMonth() + 1).padStart(2, '0');
      const y = this.toGregorianYear(e.getFullYear());
      return `${y}-${m}-${d} 12:00:00`;
    }

    let finalDate = '';

    if (typeof e === 'number') {
      const excelDate = XLSX.SSF.parse_date_code(e);
      if (!excelDate) return '';
      finalDate = `${excelDate.d}/${excelDate.m}/${excelDate.y}`;
    } else if (typeof e === 'string') {
      const value = e.trim();
      if (!value) return '';

      if (value.includes('/')) {
        finalDate = value;
      } else if (value.includes('-')) {
        const pieces = value
          .split(' ')[0]
          .split('-')
          .map(part => part.trim());

        if (pieces.length === 3) {
          const [a, b, c] = pieces;
          finalDate =
            a.length === 4
              ? `${parseInt(c, 10)}/${parseInt(b, 10)}/${parseInt(a, 10)}`
              : `${parseInt(a, 10)}/${parseInt(b, 10)}/${parseInt(c, 10)}`;
        }
      }
    }

    if (!finalDate) return '';

    const [d, m, y] = finalDate.split('/').map(part => String(part).trim());
    if (!d || !m || !y) return '';

    const gYear = this.toGregorianYear(y);
    if (!gYear) return '';

    const day = Number(d);
    const month = Number(m);
    const date = new Date(gYear, month - 1, day);
    if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(gYear) ||
        date.getFullYear() !== gYear || date.getMonth() !== month - 1 || date.getDate() !== day) return '';

    return `${gYear}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')} 12:00:00`;
  };

  resetFileInput = () => {
    document.getElementById('file').value = '';
  };

  resetState = () => {
    this.setState({ excelData: null, ArrayData: [], logError: '', apiErrors: [] });
  };
  toNumber = v => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return v;
    if (typeof v === 'string') {
      const cleaned = v.replace(/[^\d.-]/g, ''); // ตัด , เว้นวรรค และสัญลักษณ์สกุลเงิน
      const num = Number(cleaned);
      return Number.isFinite(num) ? num : 0;
    }
    return 0;
  };
  formatMoney = v => {
    const n = this.toNumber(v);
    return Number(n).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  thaiMonths = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];

  // แปลง "YYYY-MM-DD 12:00:00" -> "วัน เดือน พ.ศ. 2568"
  formatThaiDateBE = val => {
    if (!val) return '';
    // รับทั้งรูปแบบ "YYYY-MM-DD 12:00:00" หรือ "YYYY-MM-DD"
    const ymd = String(val).split(' ')[0];
    const [y, m, d] = ymd.split('-').map(n => parseInt(n, 10));
    if (!y || !m || !d) return '';
    const beYear = y > 2400 ? y : y + 543;
    return `${d} ${this.thaiMonths[m - 1]} พ.ศ. ${beYear}`;
  };
  toInt = v => {
    const n = this.toNumber(v);
    return Number.isFinite(n) ? Math.trunc(n) : 0; // ใช้ Math.trunc เพื่อตัดทศนิยม
  };
  tryParseJSON = v => {
    if (v == null) return null;
    if (Array.isArray(v) || typeof v === 'object') return v;
    if (typeof v !== 'string') return null;
    try {
      return JSON.parse(v);
    } catch (e) {
      return null;
    }
  };
  parseRevenueBudgetFromRow = row => {
    // 1) ถ้ามีคอลัมน์เป็น JSON ตรงๆ: project_revenue_budget
    const jsonVal = this.tryParseJSON(row.project_revenue_budget);
    if (Array.isArray(jsonVal)) {
      return jsonVal
        .map(x => ({
          revenue_budget_type: x.revenue_budget_type ?? '',
          revenue_budget_type_name: x.revenue_budget_type_name ?? '',
          revenue_budget_total: this.toNumber(x.revenue_budget_total),
        }))
        .filter(x => (x.revenue_budget_type || x.revenue_budget_type_name) && x.revenue_budget_total > 0);
    }

    // 2) รองรับแบบหลายคอลัมน์ _1.._20
    const items = [];
    for (let i = 1; i <= 20; i++) {
      const type = row[`project_revenue_budget_type_${i}`] ?? row[`revenue_budget_type_${i}`] ?? '';
      const typeName = row[`project_revenue_budget_type_name_${i}`] ?? row[`revenue_budget_type_name_${i}`] ?? '';
      const total = row[`project_revenue_budget_total_${i}`] ?? row[`revenue_budget_total_${i}`] ?? row[`project_revenue_budget_amount_${i}`] ?? '';

      if (type || typeName || total !== '') {
        const n = this.toNumber(total);
        if (n > 0) {
          items.push({
            revenue_budget_type: type,
            revenue_budget_type_name: typeName,
            revenue_budget_total: n,
          });
        }
      }
    }
    if (items.length) return items;

    // 3) fallback template เดิม: มีแค่ชื่อแหล่งรายรับ 1 ช่อง + ใช้ project_total_budget เป็นยอด
    if (row.project_revenue_budget_type_name) {
      const total = this.toNumber(row.project_total_budget);
      return total > 0
        ? [
            {
              revenue_budget_type: row.project_revenue_budget_type ?? '',
              revenue_budget_type_name: row.project_revenue_budget_type_name,
              revenue_budget_total: total,
            },
          ]
        : [];
    }

    return [];
  };

  parseBorrowFromRow = row => {
    // 1) ถ้ามี JSON ตรงๆ: project_borrow
    const jsonVal = this.tryParseJSON(row.project_borrow);
    if (Array.isArray(jsonVal)) {
      return jsonVal
        .map(x => ({
          borrow_project_id: x.borrow_project_id ?? '',
          borrow_project_name: x.borrow_project_name ?? '',
          borrow_total: this.toNumber(x.borrow_total),
        }))
        .filter(x => x.borrow_project_id && x.borrow_total > 0);
    }

    // 2) รองรับหลายคอลัมน์: borrow_project_id_1, borrow_project_name_1, borrow_total_1
    const items = [];
    for (let i = 1; i <= 20; i++) {
      const id = row[`borrow_project_id_${i}`] ?? '';
      const name = row[`borrow_project_name_${i}`] ?? '';
      const total = row[`borrow_total_${i}`] ?? '';

      if (id || name || total !== '') {
        const n = this.toNumber(total);
        if (id && n > 0) {
          items.push({
            borrow_project_id: id,
            borrow_project_name: name,
            borrow_total: n,
          });
        }
      }
    }
    return items;
  };

  computeTotalBudgetFromArrays = (revenueArr, borrowArr) => {
    const rSum = (revenueArr || []).reduce((s, x) => s + this.toNumber(x.revenue_budget_total), 0);
    const bSum = (borrowArr || []).reduce((s, x) => s + this.toNumber(x.borrow_total), 0);
    return rSum + bSum;
  };
  handleInputChangeFile = e => {
    e.preventDefault();
    const fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    const selectedFile = e.target.files[0];

    if (selectedFile && fileTypes.includes(selectedFile.type)) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(selectedFile);
      reader.onload = e => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'buffer' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(worksheet).map(row => ({
          ...this.normalizeImportRow(row),
          __rowNum__: row.__rowNum__,
        }));
        const ArrayData = [];
        const errors = [];
        let batch = [];
        // json.slice(1).forEach((row, index) => {
        json.forEach(row => {
          // template แบบชื่อฟิลด์อังกฤษมีแถวคำอธิบายภาษาไทยก่อนข้อมูลจริง
          if (this.getImportField(row.project_name) === 'project_name' &&
              this.getImportField(row.project_start) === 'project_start' &&
              this.getImportField(row.project_finish) === 'project_finish') return;
          const excelRow = row.__rowNum__ + 1;
          if (!String(row.project_name ?? '').trim()) {
            errors.push(`แถว ${excelRow}: กรุณากรอกชื่อโครงการ`);
            return;
          }
          const projectStart = this.chengDate(row.project_start);
          const projectFinish = this.chengDate(row.project_finish);
          // ตรวจสอบวันที่เริ่มต้นและสิ้นสุด
          if (!projectStart || !projectFinish) {
            errors.push(`แถว ${excelRow}: กรุณากรอกวันที่เริ่มต้นและวันที่สิ้นสุดให้ถูกต้อง`);
            return; // ข้ามไปยังรอบถัดไป
          }

          // ตรวจสอบหน่วยงาน
          if (!row.project_department_name) {
            errors.push(`แถว ${excelRow}: กรุณากรอกหน่วยงาน`);
            return; // ข้ามไปยังรอบถัดไป
          }

          // ตรวจสอบแหล่งที่มาของรายได้
          // if (!row.project_revenue_budget_type_name && !row.project_expenditure_budget_type_name && !row.project_total_budget) {
          //   showAlert('ข้อมูลไม่ครบถ้วน', 'กรุณากรอกแหล่งที่มาของรายได้');
          //   return; // ข้ามไปยังรอบถัดไป
          // }

          const projectRevenueBudget = this.parseRevenueBudgetFromRow(row);
          const projectBorrow = this.parseBorrowFromRow(row);
          const projectBorrowStatus = projectBorrow.length > 0 ? 1 : 0;
          const computedTotal = this.computeTotalBudgetFromArrays(projectRevenueBudget, projectBorrow);
          const fileTotal = this.toNumber(row.project_total_budget);
          const finalTotalBudget = fileTotal > 0 ? fileTotal : computedTotal;

          // validation แหล่งงบ (ใหม่): ต้องมีรายรับหรือเงินยืมอย่างน้อย 1 รายการ และยอดรวม > 0
          // if ((projectRevenueBudget.length === 0 && projectBorrow.length === 0) || finalTotalBudget <= 0) {
          //   showAlert('ข้อมูลไม่ครบถ้วน', 'กรุณากรอกแหล่งที่มาของเงินงบประมาณและจำนวนเงินให้ถูกต้อง');
          //   return;
          // }
          batch.push({
            project_name: row.project_name || '',
            project_start: projectStart,
            project_finish: projectFinish,
            project_object: row.project_object || '',
            project_output_goal: row.project_output_goal || '',
            project_outcome_goal: row.project_outcome_goal || '',
            project_expected_benefit: row.project_expected_benefit || '',
            project_benefit: row.project_benefit || '',
            project_type_name: row.project_type_name || '',
            project_national_strategy_name: row.project_national_strategy_name || '',
            project_master_plan_name: row.project_master_plan_name || '',
            project_development_plan_name: row.project_development_plan_name || '',
            project_development_goal_name: row.project_development_goal_name || '',
            project_province_strategy_name: row.project_province_strategy_name || '',
            project_local_strategy_name: row.project_local_strategy_name || '',
            project_municipality_strategy_name: row.project_municipality_strategy_name || '',
            project_sub_strategy_name: row.project_sub_strategy_name || '',
            project_non_livable_name: row.project_non_livable_name || '',
            project_it_master_plan_name: row.project_it_master_plan_name || '',
            project_smart_city_name: row.project_smart_city_name || '',
            project_plan_name: row.project_plan_name || '',
            project_policy_name: row.project_policy_name || '',

            project_revenue_budget: projectRevenueBudget,
            project_borrow_status: projectBorrowStatus,
            project_borrow: projectBorrow,

            project_revenue_budget_type_name: row.project_revenue_budget_type_name || '',
            project_expenditure_budget_type_name: row.project_expenditure_budget_type_name || '',

            project_total_budget: Math.trunc(finalTotalBudget),
            // project_total_budget: this.toInt(row.project_total_budget) || '',
            project_department_name: row.project_department_name || '',
            project_responsible: row.project_responsible || '',
            project_note: row.project_note || '',
            create_user_data: row.create_user_data || '',
            project_status: row.project_status || '',
          });
        });

        if (batch.length) ArrayData.push(batch);
        this.setState({ excelData: json, ArrayData, logError: errors.join('\n'), apiErrors: [] });
        if (errors.length) {
          Swal.fire({
            title: 'ข้อมูลไม่ครบถ้วน',
            text: errors.join('\n'),
            icon: 'warning',
          });
        }
      };

      reader.onerror = () => {
        Swal.fire({
          title: 'Error reading file',
          text: 'Could not read the file. Please check the file format.',
          icon: 'error',
          timer: 2500,
        });
      };
    } else {
      Swal.fire({
        title: 'ไฟล์ไม่ถูกต้อง',
        text: 'อนุญาตเฉพาะไฟล์ xlsx และ xls เท่านั้น',
        icon: 'error',
        timer: 2500,
      });
      this.resetFileInput();
    }
  };

  showImportError = data => {
    const message = typeof data.message === 'string' ? data.message : 'ไม่สามารถนำเข้าข้อมูลได้ กรุณาลองใหม่';
    const apiErrors = (Array.isArray(data.data_errors) ? data.data_errors : []).map(item => {
      const matchingRows = (this.state.excelData || []).filter(row =>
        row.project_name === item.project_name && Number.isInteger(row.__rowNum__));
      const details = Array.isArray(item.error) ? item.error : [item.error || 'กรุณาตรวจสอบข้อมูล'];
      return {
        name: item.project_name || 'ไม่ระบุชื่อโครงการ',
        rows: matchingRows.map(row => row.__rowNum__ + 1),
        details: details.map(detail => typeof detail === 'string' ? detail : JSON.stringify(detail)),
      };
    });
    this.setState({ logError: message, apiErrors, loading: false });
    Swal.fire({
      title: 'นำเข้าข้อมูลไม่สำเร็จ',
      text: apiErrors.length
        ? `พบข้อมูลที่ต้องตรวจสอบ ${apiErrors.length} รายการ ดูชื่อโครงการและรายละเอียดในตารางด้านล่าง`
        : message,
      icon: 'warning',
      confirmButtonText: 'ดูรายละเอียด',
    });
  };

  handleSubmit = () => {
    const { ArrayData } = this.state;
    if (this.state.loading || !ArrayData.flat().length) return;
    this.setState({ loading: true, logError: '', apiErrors: [] });
    const promises = ArrayData.map(batch =>
      axios.post(process.env.REACT_APP_SOURCE_URL + '/projects/importExcel', batch, {
        headers: { Authorization: `Bearer ${token_id}` },
      }),
    );

    return Promise.all(promises)
      .then(responses => {
        const failed = responses.find(response => response.data &&
          (response.data.success === false || (Array.isArray(response.data.data_errors) && response.data.data_errors.length)));
        if (failed) {
          this.showImportError(failed.data);
          return;
        }
        this.setState({ excelData: null, ArrayData: [], logError: '', apiErrors: [], loading: false });
        document.getElementById('file').value = '';
        Swal.fire({
          title: 'บันทึกข้อมูลสำเร็จ',
          icon: 'success',
          timer: 1000,
        });
      })
      .catch(err => {
        this.showImportError((err.response && err.response.data) || {
          message: 'ไม่สามารถเชื่อมต่อระบบได้ กรุณาลองใหม่',
        });
      });
  };

  render() {
    const { logError, apiErrors, excelData, ArrayData, loading } = this.state;
    const headers = Object.keys(textTd);
    return (
      <>
        <Row>
          <Col sm={12}>
            <span>
              Download template:{' '}
              <a href="/template.xlsx" download>
                template.xlsx
              </a>
            </span>
          </Col>
          <Label for="file" sm={12}>
            แนบไฟล์:
          </Label>
          <Col sm={12}>
            <input
              name="file"
              id="file"
              type="file"
              className="form-control"
              style={{
                width: '100%',
                height: 'fit-content',
                padding: '0',
              }}
              onChange={this.handleInputChangeFile}
            />
            <FormText>คาดหวังประเภทไฟล์ 'xlsx'</FormText>
          </Col>
        </Row>
        {logError && (
          <div className="alert alert-danger" role="alert" style={{ whiteSpace: 'pre-line' }}>
            {logError}
          </div>
        )}
        {apiErrors.length > 0 && (
          <div className="mb-3" role="region" aria-label="รายละเอียดข้อผิดพลาดจากการนำเข้า">
            <p><strong>พบข้อมูลที่ต้องตรวจสอบ {apiErrors.length} รายการ</strong> กรุณาแก้ข้อมูลใน Excel ให้ตรงกับข้อมูลอ้างอิงในระบบ แล้วเลือกไฟล์ใหม่</p>
            <div className="table-responsive" style={{ maxHeight: 480, overflowY: 'auto' }}>
              <table className="table table-bordered table-striped">
                <thead><tr><th>แถว Excel</th><th>ชื่อโครงการ</th><th>ข้อมูลที่ต้องตรวจสอบ</th></tr></thead>
                <tbody>{apiErrors.map((error, index) => (
                  <tr key={index}>
                    <td>{error.rows.length ? error.rows.join(', ') : '—'}</td>
                    <td style={{ minWidth: 220, whiteSpace: 'pre-wrap' }}>{error.name}</td>
                    <td style={{ minWidth: 320 }}><ul className="mb-0 pl-3">{error.details.map((detail, i) => (
                      <li key={i} style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{detail}</li>
                    ))}</ul></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </div>
        )}
        <Row className="justify-content-center">
          <Col sm={1}>
            <Button
              onClick={this.handleSubmit}
              disabled={!ArrayData.length || loading} // ตรวจสอบ ArrayData และสถานะ loading
              color="primary"
            >
              {loading ? <Spinner size="sm" /> : 'Upload'} {/* แสดง spinner เมื่อโหลด */}
            </Button>
          </Col>
          <Col sm={1}>
            <Button
              onClick={() => {
                this.setState({ excelData: null, ArrayData: [], logError: '', apiErrors: [] });
                document.getElementById('file').value = ''; // รีเซ็ต input file
              }}
              color="danger"
            >
              Clear
            </Button>
          </Col>
        </Row>
        <div className="col-md-12 viewer">
          {excelData ? (
            <table className="table table-responsive">
              <thead>
                <tr style={{ backgroundColor: '#e0ecfa' }}>
                  {headers.map(key => (
                    <th key={key}>{textTd[key]}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ArrayData.flat().length ? (
                  ArrayData.flat().map((row, index) => (
                    <tr key={index}>
                      {headers.map(key => (
                        <td key={key}>
                          {key === 'project_total_budget'
                            ? this.formatMoney(row[key]) // แสดง 100,000.00
                            : key === 'project_start' || key === 'project_finish'
                            ? this.formatThaiDateBE(row[key]) // แสดง วัน เดือน พ.ศ.
                            : row[key]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={headers.length} className="text-center">
                      ไม่มีข้อมูล
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <p>กรุณาเลือกไฟล์</p>
          )}
        </div>
      </>
    );
  }
}
